import { QuestionResolutionError } from '@/errors/questionResolution';
import Activity from '@/models/Activity';
import { Question } from '@/models/Question';
import LegacyActivity from '@/models/_deprecated/Activity';
import ActivityElement from '@/models/_deprecated/ActivityElement';

type ResolvableQuestion = Pick<
  Question | ActivityElement,
  'id' | 'identifier' | 'type'
>;

type ResolvableActivity = Pick<Activity | LegacyActivity, 'id' | 'questions'>;

export function resolveQuestionInActivity<T extends ResolvableQuestion>(
  activity: ResolvableActivity,
  question: T,
): T {
  const questions: ResolvableQuestion[] = activity.questions;
  const matches = questions.filter(
    item =>
      item.identifier === question.identifier && item.type === question.type,
  );

  if (matches.length !== 1) {
    throw new QuestionResolutionError();
  }

  return matches[0] as T;
}
